import { prependRoot } from "../util/prependRoot.js";
import { getApiRoot } from "../store/configureStore.js";
import axios from "axios";

const routePrefix = "/sportclub/";

const SportclubApi = {
    searchSportclubs(federatieId, searchModel) {
        const serviceUrl = prependRoot(routePrefix + 'searchsportclubs/' + federatieId, getApiRoot());
        return axios.put(serviceUrl, searchModel, {
            header: {
                accept: "application/json"
            }
        });
    },
    searchSportclubsGemeente(gemeenteId, searchModel) {
        const serviceUrl = prependRoot(routePrefix + 'searchsportclubsGemeente/' + gemeenteId, getApiRoot());
        return axios.put(serviceUrl, searchModel, {
            header: {
                accept: "application/json"
            }
        });
    },
    requestLinkSportclub(sportclubId) {
        const serviceUrl = prependRoot(routePrefix + 'requestLinkSportclub/' + sportclubId, getApiRoot());
        return axios.put(serviceUrl, {
            header: {
                accept: "application/json"
            }
        });
    },
    requestLinkSportclubGemeente(sportclubId, gemeenteId) {
        const serviceUrl = prependRoot(routePrefix + 'requestLinkSportclubGemeente/' + sportclubId + '/' + gemeenteId, getApiRoot());
        return axios.put(serviceUrl, {
            header: {
                accept: "application/json"
            }
        });
    }
};

export default SportclubApi;